<template>
    <div class="text-bzMenuText">
        <slot />
    </div>
</template>